import { bytesToHex } from "@noble/hashes/utils.js";
import { decryptBytes, encryptBytes, DEFAULT_KDF } from "./crypto.js";
import { newDeviceKey, openRestoredVault } from "./recovery.js";
import { VaultInputError } from "./secret.js";
import { createVault, vaultPasswordProblem } from "./vault.js";
const keyAad = (network, userId, requestId) => `custos-vault-restore-key:v1:${network}:${userId}:${requestId}`;
/** Step 1a: checks the new password and makes the one-time device key. */
export function beginRestore(newPassword) {
    const problem = vaultPasswordProblem(newPassword);
    if (problem)
        throw new VaultInputError(problem);
    const { secretKey, publicKey } = newDeviceKey();
    return { publicKeyHex: bytesToHex(publicKey), secretKey };
}
/** Step 1b: once the API has created the request, keep the device key (encrypted) until it's approved. */
export async function savePendingRestore(store, network, userId, requestId, key, newPassword, opts = {}) {
    try {
        const blob = await encryptBytes(key.secretKey, newPassword, keyAad(network, userId, requestId), opts.kdf ?? DEFAULT_KDF);
        await store.putRestore({ network, userId, requestId, createdAt: new Date().toISOString(), blob });
    }
    finally {
        key.secretKey.fill(0);
    }
}
/** Step 2: opens the restore box with the device key and saves the vault on this device. */
export async function finishRestore(store, network, password, box, opts = {}) {
    const pending = await store.getRestore(network);
    if (!pending)
        throw new VaultInputError("This device has no recovery waiting. Start the recovery again.");
    const deviceKey = await decryptBytes(pending.blob, password, keyAad(network, pending.userId, pending.requestId));
    try {
        const secret = openRestoredVault(box, deviceKey, network, pending.userId, pending.requestId);
        if (await store.get(network))
            await store.delete(network); // replaced by the recovered vault
        const unlocked = await createVault(store, network, secret, password, opts);
        await store.deleteRestore(network);
        return unlocked;
    }
    finally {
        deviceKey.fill(0);
    }
}
//# sourceMappingURL=restore.js.map